import { Directive, forwardRef, Inject, Input, Optional } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator, ValidatorFn } from '@angular/forms';
import * as R from 'ramda';

import { InputType } from '../../models';
import { defaultFormatter, Formatter } from './formatter';
import { InputTypeConfig, InputTypeConfigToken } from './input-type-provider';
import { defaultMatcher, InputKeyboardEventMatcher } from './matcher';
import { defaultParser, Parser } from './parser';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'pcs-input',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: forwardRef(() => InputTypeDirective),
    multi: true
  }]
})
export class InputTypeDirective implements Validator, InputTypeConfig {
  @Input() inputType = InputType.STRING;

  formatter: Formatter = defaultFormatter;
  parser: Parser = defaultParser;
  isKeyAllowed: InputKeyboardEventMatcher = defaultMatcher;
  validator: ValidatorFn = R.always(null);

  constructor(@Inject(InputTypeConfigToken) @Optional() private inputTypeConfig: InputTypeConfig) {
    this.initialize();
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return this.validator(control);
  }

  private initialize() {
    if (this.inputTypeConfig) {
      this.formatter = this.inputTypeConfig.formatter;
      this.parser = this.inputTypeConfig.parser;
      this.isKeyAllowed = this.inputTypeConfig.isKeyAllowed;
      this.validator = this.inputTypeConfig.validator;
    }
  }

}
